import { observer } from "mobx-react-lite";
import FiltersStore from "../stores/FiltersStore";
import FilterButton from "./FilterButton";
import Select2 from "./Select2";
import SortIcon from "../icons/SortIcon";
import BadgeIcon from "./BadgeIcon.jsx";
import { _t } from '../utils/Lang';
;

const FiltersFabrics = observer(({ filtersStore, mode = '', hideSorting = false, hideProperties = false }: { filtersStore: FiltersStore, mode?: "swatches", hideSorting?: boolean, hideProperties?: boolean }) => {


    return (
        <div className="filters-fabrics">

            {/* filters */}
            <div className="d-flex g-2 wrap">
                <Select2
                    style={{ display: hideProperties ? 'none' : '', width: 180 }}
                    closeAfterSelection={false}
                    maxHeightDropdown={200}
                    minWidthDropdown={220}

                    value={filtersStore.getFilterValue('characteristics')}
                    options={filtersStore.getOptions('characteristics')}
                    multiple={true}
                    onChange={(e, option) => {
                        filtersStore.setFilterValue('characteristics', option.value);
                    }}

                    renderDisplayed={(options) => {
                        // if (options.length === 1) return options[0].label;
                        return <>{_t('filter_properties')}&nbsp;<span className="dot">{options.length}</span></>
                    }}

                    renderOption={(option) => {
                        return (
                            <div className="d-flex a-center g-1">
                                <span className="me-auto">{option.label}</span>
                                <span className=""><BadgeIcon name={option.iconName} /></span>
                            </div>
                        )
                    }}

                    className="Select2--radius" placeholder={_t('filter_properties_ph')} />

                <Select2
                    closeAfterSelection={false}
                    maxHeightDropdown={200}
                    minWidthDropdown={160}

                    style={{
                        width: 110,
                    }}


                    onChange={(e, option) => {
                        filtersStore.setFilterValue('colors', option.value);
                    }}
                    multiple={true}
                    value={filtersStore.getFilterValue('colors')}
                    options={filtersStore.getOptions('colors')}
                    renderDisplayed={(options) => {
                        // if (options.length === 1) return options[0].label;
                        return <>{_t('filter_colors')}&nbsp;<span className="dot">{options.length}</span></>
                    }}

                    className="Select2--radius" placeholder={_t('filter_colors')} />
                {
                    mode === 'swatches' ? (
                        <span className="me-auto"></span>
                    ) : null
                }
                <div className="Select2__icon" style={{ display: hideSorting ? 'none' : '', width: 120 }}>
                    <Select2
                        className="Select2--radius"
                        placeholder={_t('filter_sort')}
                        maxWidth={120}
                        minWidthDropdown={160}
                        multiple={false}
                        options={filtersStore.getOptions('sorting')}
                        value={filtersStore.getFilterValue('sorting')}
                        onChange={(e, option) => {
                            filtersStore.setFilterValue('sorting', option.value);
                        }}
                        renderDisplayed={(option) => {
                            return <div className="Select2__icon truncate"><SortIcon /> {_t('filter_sort')}</div>
                        }}
                        renderPlaceholder={({ placeholder }) => {
                            return <div className="Select2__icon"><SortIcon /> {placeholder}</div>
                        }}
                    />
                </div>


            </div>

            {/* set filters */}
            <div className="mt-2 mb-2 d-flex g-1 wrap w-100">
                {
                    filtersStore.getSelectedOptions('characteristics').map((color, index) => {
                        return <FilterButton key={index} filter={{ category: '', label: color.label, value: color.value }} onClick={() => {
                            filtersStore.setFilterValue('characteristics', color.value);
                        }} />
                    })
                }
                {
                    filtersStore.getSelectedOptions('colors').map((color, index) => {
                        return <FilterButton key={index} filter={{ category: '', label: color.label, value: color.value }} onClick={() => {
                            filtersStore.setFilterValue('colors', color.value);
                        }} />
                    })
                }
                <button
                    style={{ display: filtersStore.hasFilters ? 'block' : 'none' }}
                    onClick={() => {
                        filtersStore.resetFilters();
                    }}
                    type="button" className="FilterButton__clear">{_t('filter_clear')}</button>

            </div>

        </div>
    );
});

export default FiltersFabrics;